'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconQrcodeRead, iconQrcodeReadTag } from '@ni/nimble-components/dist/esm/icons/qrcode-read';
import { wrap } from '../../utilities/react-wrapper';

export type { IconQrcodeRead };
export { iconQrcodeReadTag };
export const NimbleIconQrcodeRead = wrap(IconQrcodeRead);